// extracted by mini-css-extract-plugin
export var standaloneTable = "_g0-0";
export var withExtraHeader = "_g0-1";